import { IUserInfoDto } from '../api'

const USER_INFO_STORAGE_KEY = 'userInfo'

const getUserInfoFromStorage = (): IUserInfoDto | null => {
    return localStorage ? JSON.parse(localStorage.getItem(USER_INFO_STORAGE_KEY)) : null
}

const setUserInfoInStorage = (userInfo: IUserInfoDto | null) => {
    localStorage?.setItem(USER_INFO_STORAGE_KEY, JSON.stringify(userInfo))
}

const updateUserInfoInStorage = (partialUserInfo: Partial<IUserInfoDto>): boolean => {
    const userInfo = getUserInfoFromStorage() ?? ({} as IUserInfoDto)

    if (userInfo) {
        setUserInfoInStorage({ ...userInfo, ...partialUserInfo })
        return true
    }
    return false
}

export { getUserInfoFromStorage, setUserInfoInStorage, updateUserInfoInStorage }
